import { Student } from '@innovamat/glow-api-client';

function getFullName(student: Student): string {
  if (student.isInvitation) return student.email ?? '';
  return `${student?.firstName} ${student?.lastName}`;
}

export { getFullName };
